// extracted by mini-css-extract-plugin
export default {"toggle":"Modal_toggle__t2Uby"};